interface HomePageJsonLdParams {
  url: string;
  name: string;
  alternateName: string[];
}

// Собирает JSON-LD разметку WebSite для главной страницы.
export const buildHomePageJsonLd = ({ url, name, alternateName }: HomePageJsonLdParams) => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url,
  name,
  alternateName,
});
